<template>
    <div class="email-subscription-content">
        <div v-if="createMode && canManageSchedules">
            <EmailScheduleCreateForm
                :reportTypeCode="reportTypeCode"
                @created="$emit('created')"
                @cancel="$emit('cancel')"
            />
        </div>
        <div v-else>
            <div class="email-header">
                <h3>Email Subscriptions</h3>
                <Button v-if="canManageSchedules" @click="$emit('create')" variant="primary">
                    <i class="fas fa-plus"></i>
                    Create Schedule
                </Button>
            </div>

            <div class="email-schedules">
                <CustomTable v-if="emailSchedules.length">
                    <template #head>
                        <tr>
                            <th>Name</th>
                            <th>Send To</th>
                            <th>Time</th>
                            <th>Schedule</th>
                            <th v-if="canManageSchedules">Actions</th>
                        </tr>
                    </template>
                    <template #body>
                        <tr v-for="emailSchedule of emailSchedules" :key="emailSchedule.id">
                            <td>#{{ emailSchedule.name }}</td>
                            <td>{{ emailSchedule.email_to_send }}</td>
                            <td>{{ formatTimeToAMPM(emailSchedule.time) }}</td>
                            <td>{{ getRepeatName(emailSchedule) }}</td>
                            <td v-if="canManageSchedules">
                                <i
                                    @click="$emit('delete', emailSchedule.id)"
                                    class="fas fa-trash delete-icon"
                                />
                            </td>
                        </tr>
                    </template>
                </CustomTable>
                <UiState v-else type="empty" title="No email schedules found" compact />
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "../layout/CustomTable.vue"
import Button from "../UI/Button.vue"
import UiState from "../UI/UiState.vue"
import EmailScheduleCreateForm from "./EmailScheduleCreateForm.vue"
import { formatTimeToAMPM } from "../../utils/common"

export default {
    name: "ReportEmailSubscriptions",
    components: {
        EmailScheduleCreateForm,
        CustomTable,
        Button,
        UiState,
    },
    props: {
        createMode: {
            type: Boolean,
            default: false,
        },
        reportTypeCode: {
            type: String,
            default: "",
        },
        emailSchedules: {
            type: Array,
            default: () => [],
        },
        canManageSchedules: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        formatTimeToAMPM,
        getRepeatName(emailSchedule) {
            if (emailSchedule.repeat_monthly) {
                return "Monthly"
            }
            if (emailSchedule.repeat_daily) {
                return "Daily"
            }
            if (emailSchedule.repeat_once) {
                return "Once"
            }
            return ""
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.email-subscription-content {
    padding-top: 20px;
}

.email-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid $lightBorderColor;

    h3 {
        color: $primaryColor;
        font-size: 20px;
        font-weight: 600;
        margin: 0;
    }
}

.email-schedules {
    background: $lightCardBg;
    border-radius: 16px;
    border: 1px solid $lightBorderColor;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.delete-icon {
    color: $dangerColor;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        background: rgba($dangerColor, 0.1);
        color: darken($dangerColor, 10%);
    }
}
</style>
